import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';

export default function Navbar({ onLogout }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    onLogout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <h2>Mazatlán Calendar</h2>
      </div>
      <div className="navbar-center">
        <button onClick={() => navigate('/dashboard')} className="nav-link">Dashboard</button>
        <button onClick={() => navigate('/inquiries')} className="nav-link">Inquiries</button>
        <button onClick={() => navigate('/gallery')} className="nav-link">Gallery</button>
        <button onClick={() => navigate('/site-content')} className="nav-link">Content</button>
        <button onClick={() => navigate('/notifications')} className="nav-link">Notifications</button>
        <button onClick={() => navigate('/telegram-settings')} className="nav-link">Telegram</button>
        <button onClick={() => navigate('/settings')} className="nav-link">Settings</button>
      </div>
      <div className="navbar-right">
        <button onClick={handleLogout} className="logout-btn">Logout</button>
      </div>
    </nav>
  );
}
